export const STAFF_RESPONDER = 'staff responder';
export const STAFF_SUBMITTER = 'staff submitter';
export const OTHER = 'other';

export const SUBMITTER_STAFF_ROLE_ID = '40e6215d-b5c6-4896-987c-f30f3678f608';